import React, { Component } from "react";
import { Modal, Spin, message, Button, Form, Select } from "antd";
import { observer } from "mobx-react";

const FormItem = Form.Item;
const Option = Select.Option;

@Form.create({})
@observer
class DownloadKMArticlesDialog extends Component {
	hideDialog = () => {
		this.props.hideDialog();
    };
    downloadKMArticles = () => {
        this.props.form.validateFieldsAndScroll((err, vals) => {
            if (err != null) {
                return;
            }
            let kmCampaignId = this.props.form.getFieldValue("campaign");
            this.props.downloadKMArticles(kmCampaignId);
        })        
    }

	render() {
		return (
			<Modal
				visible={this.props.dialogVisible}
				title="Download Kontent Machine Articles"
				okText="OK"
				closable={false}
				maskClosable={false}
				destroyOnClose={true}
				footer={[
					<Button key="close" onClick={this.hideDialog} disabled={this.props.downloadingKMArticles}>
						Close
					</Button>,
                    <Button key="Download" type="primary" onClick={this.downloadKMArticles}>
                        Download
                    </Button>
				]}
			>
				<Spin spinning={this.props.downloadingKMArticles == true}>
					<Form>
						<FormItem label="Kontent Machine Campaign">
							{this.props.form.getFieldDecorator("campaign", {
								rules: [
									{
										required: true,
										message: "Please select a campaign"
									}
								]
							})(
								<Select placeholder="Select a campaign">
									{this.props.kmCampaigns.map(campaign => {
										return (
											<Option key={campaign.id} value={campaign.id}>
												{campaign.name}
											</Option>
										);
									})}
								</Select>
							)}
						</FormItem>
						<FormItem>
							<Button
								type="primary"
								onClick={this.props.updateKMCampaigns}
								loading={this.props.updatingKMCampaigns}
							>
								Update Campaigns
							</Button>
						</FormItem>
					</Form>
				</Spin>
			</Modal>
		);
	}
}

export default DownloadKMArticlesDialog;
